import React from 'react';
import DFP_LOGO_COMPACT from '../../../../../images/finsuite-logo-compact.svg';
import { AppLogoStatic } from 'src/components/dfp-home-page/top-navigation/TopNavLogo';
import 'src/components/dfp-home-page/top-navigation/DFPTopNavigation.scss';

interface EmbeddedNavPreviewProps {
  selectedLogoName: string | null;
  previewUrl: string | null;
  displayName: string;
}

const EmbeddedNavPreview: React.FC<EmbeddedNavPreviewProps> = ({ selectedLogoName, previewUrl, displayName }) => (
  <nav className="dfp-top-nav dfp-top-nav--preview" aria-label="Navigation preview">
    <div className="dfp-top-nav__left">
      <span className="dfp-top-nav__logo-link">
        <img src={DFP_LOGO_COMPACT} alt="FinSuite Logo" className="dfp-top-nav__logo" />
      </span>
      <div className="dfp-top-nav__app_text">
        {(selectedLogoName || previewUrl) && (
          <span className="dfp-top-nav__app-logo-wrapper">
            <AppLogoStatic selectedLogoName={selectedLogoName} previewUrl={previewUrl} />
          </span>
        )}
        <span className="dfp-top-nav__app-name">{displayName.toLowerCase()}</span>
      </div>
    </div>
  </nav>
);

export default EmbeddedNavPreview;
